<template>
  <div class="home-container">
    <main class="home">
      <img
        class="logo"
        src="../assets/logo.png"
        alt="Logo"
      />

      <div class="textbox">
        <h1>Darts Tournament and Scoring System</h1>
        <p>
          Play local games with your friends or play against a bot.
          Register for online games against other Player or host a tournament.
          Look at the stats of the last 20 online games or watch other torunaments live.
        </p>
      </div>

      <div class="actions">
        <BaseButton
          text="Quick Game BO5 Legs 501"
          to="game?mode=quick"
        />
        <BaseButton 
        text="Create Custom Game" 
        to="config"
        />
      </div>

      <div class="auth">
        <BaseButton text="Register" to="register"/>
        <BaseButton text="Login" to="login"/>
      </div>
    </main>

    <AppFooter />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BaseButton from '@/components/atoms/BaseButton.vue';
import AppFooter from '@/components/atoms/AppFooter.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    BaseButton,
    AppFooter,
  },
});
</script>

<style scoped>
.home-container {
  box-sizing: border-box;
  height: 95dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.home {
  box-sizing: border-box;
  flex: 1;
  min-height: 0;
  padding: 24px 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 160px;
  height: 160px;
  object-fit: contain;
  flex-shrink: 0;
}

.textbox {
  width: 100%;
  max-width: 400px;
  margin: 8px 0 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.textbox h1 {
  margin: 0 0 8px;
  font-size: 1.8rem;
  color: var(--color-primary);
}

.textbox p {
  margin: 0;
  color: var(--color-text);
}

.actions {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth {
  width: 85%;
  max-width: 370px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}
</style>
